import moment from 'moment'
import { HolidaysProps } from "../module/ApprovalHours/components/Table/sub-module/TbodyComponent";

export function filterValidHolidays(holidays: HolidaysProps[]) {
  return holidays.filter((holiday) => {
    const date = moment(`${holiday.date}-${holiday.year}`, 'MM-DD-YYYY')  
    return date.day() !== 0 && date.day() !== 6
  })
}